import React, { Component } from 'react';
import _validator from 'modules/validator';
import _AdminService from '../../modules/AdminService';
import _notification from 'modules/notification';
import { Row, Col } from 'antd';
import LoadingSpinner from 'components/enterprise/LoadingSpinner';
import PageHeader from 'components/enterprise/PageHeader';
import _EnterpriseOpsService from 'modules/EnterpriseOpsService';
import StatCard from 'components/enterprise/StatCard';
import Card from 'components/enterprise/Card';
import StatusBadge from 'components/enterprise/StatusBadge';
import { routesAdmin } from 'routes/Routes';


class Dashboard extends Component {
    constructor(props) {
        super(props);
        this.textInput = React.createRef()
        this.state = {
            data: [],
            loading: false,
            totalRegisteredCandidatesCount: [],
            // Dashboard Performance phase (28 Aug 2026): independent of `loading` above — previously
            // getDashboardData() and getTotalStudentRegisterData() shared the single `loading` flag, so
            // whichever of the two resolved first (always getDashboardData(), a fixed-cost query) flipped
            // it to false and let the whole page — including the Post Wise section, before its own data
            // had arrived — render immediately. The section then silently rendered as an empty grid and
            // "popped in" several seconds later when the slower call finally resolved, with no loading
            // indicator to explain the wait. Mirrors the existing enterpriseLoading pattern below.
            postWiseLoading: false,
            // Sprint 2.4 (Admin Dashboard Modernization): additive state for the new Sprint 2.3
            // operational/health/compliance sections. Kept independent of `loading` above so a slow
            // or failed Sprint 2.3 call never blocks the existing candidate-status KPIs from rendering.
            enterpriseLoading: false,
            operationalMetrics: null,
            healthStatus: null,
            complianceSummary: null
        };
    }

    componentDidMount() {
        this.getDashboardData();
        this.getTotalStudentRegisterData();
        this.getEnterpriseDashboardData();
    }

    // Sprint 2.4: extends the existing dashboard with Sprint 2.3's Operational/Health/Compliance
    // APIs, which had no frontend consumer before this sprint. Does not touch or replace anything above.
    getEnterpriseDashboardData = async () => {
        this.setState({ enterpriseLoading: true });
        try {
            const [operationalResponse, healthResponse, complianceResponse] = await Promise.all([
                _EnterpriseOpsService.getOperationalMetrics().catch(() => null),
                _EnterpriseOpsService.getHealthStatus().catch(() => null),
                _EnterpriseOpsService.getComplianceMetrics().catch(() => null)
            ]);

            this.setState({
                operationalMetrics: operationalResponse ? operationalResponse.data : null,
                healthStatus: healthResponse ? healthResponse.data : null,
                complianceSummary: complianceResponse ? complianceResponse.data : null,
                enterpriseLoading: false
            });
        } catch (e) {
            this.setState({ enterpriseLoading: false });
        }
    }

    //API operations
    getDashboardData = async () => {
        try {
            this.setState({ loading: true }, async () => {
                try {
                    let dashboardList = await _AdminService.GetAdminDashboardData();
                    //console.log("dashboardList Data: ", dashboardList.data);


                    this.setState({
                        ...this.state,
                        data: dashboardList.data,
                        loading: false,
                    });

                } catch (e) {
                    // TODO
                    this.setState({ loading: false });
                    console.log('Error: ', e);
                }
            });
        } catch (e) { }
    }

    //API operations
    getTotalStudentRegisterData = async () => {
        try {
            this.setState({ postWiseLoading: true }, async () => {
                try {
                    let totalRegisteredCandidatesCount = await _AdminService.GetTotalStudentRegisterData();

                    this.setState({
                        ...this.state,
                        totalRegisteredCandidatesCount: totalRegisteredCandidatesCount.data.Obj.studentRegisterDataModel,
                        postWiseLoading: false,
                    });

                } catch (e) {
                    // TODO
                    this.setState({ postWiseLoading: false });
                    console.log('Error: ', e);
                }
            });
        } catch (e) { }
    }

    //const StudentPersonalInfo = () => {
    render() {
        if (this.state.loading)
            return <LoadingSpinner />

        const pendingForReview = (this.state.data.TotalSubmittedCandidates - (this.state.data.TotalFormVerifiedCandidates + this.state.data.TotalFormRejectedCandidates)) || 0;
        const totalRejected = this.state.data.TotalFormRejectedCandidates || 0;

        return (
            <div className="ent-admin-page">
                <PageHeader
                    title="Dashboard"
                    subtitle="Registration, payment, and operational overview for the current recruitment cycle."
                    breadcrumbItems={[{ label: 'Dashboard' }]}
                />

                {/* Sprint 2.6.3 (Enterprise Operations Console): swapped raw antd Card/Statistic tiles for
                    StatCard (already used below in the Sprint 2.4 block) — same data, same
                    GetAdminDashboardData/GetTotalStudentRegisterData calls, presentation only. */}
                <div className="ent-section">
                    <div className="ent-section-title">Total Candidate Registration Count</div>
                    <Row gutter={[16, 16]}>
                        <Col xs={24} sm={12} md={6}>
                            <StatCard label="Candidate Registered" value={this.state.data.TotalRegisteredCandidates} tone="info" />
                        </Col>
                        <Col xs={24} sm={12} md={6}>
                            <StatCard label="Registration In Progress" value={this.state.data.TotalInProcessCandidates} tone="info" />
                        </Col>
                        <Col xs={24} sm={12} md={6}>
                            <StatCard label="Forms Submitted" value={this.state.data.TotalSubmittedCandidates} tone="info" />
                        </Col>
                        <Col xs={24} sm={12} md={6}>
                            <StatCard label="Pending for Review" value={pendingForReview} tone={pendingForReview > 0 ? 'warning' : 'success'} />
                        </Col>
                        <Col xs={24} sm={12} md={6}>
                            <StatCard label="Forms Rejected" value={totalRejected} tone={totalRejected > 0 ? 'error' : 'success'} />
                        </Col>
                        <Col xs={24} sm={12} md={6}>
                            <StatCard label="Forms Verified & Approved" value={this.state.data.TotalFormVerifiedCandidates} tone="success" />
                        </Col>
                        <Col xs={24} sm={12} md={6}>
                            <StatCard label="Total Hall Ticket Download" value={this.state.data.TotalExamCardDownloadCandidates ? this.state.data.TotalExamCardDownloadCandidates : 0} tone="info" />
                        </Col>
                    </Row>
                </div>

                {/* Admin Dashboard Home Page UX Refinement phase: this section previously rendered
                    each post's Registered/Approved counts as two independent StatCards placed as
                    flat siblings in one grid — with several posts in play, the grid interleaved
                    "X — Registered", "X — Approved", "Y — Registered", "Y — Approved"... with no
                    visual grouping, making Post → its own counts non-obvious at a glance (reported
                    defect, confirmed against the actual screenshot). Same data/API/calculation
                    (totalRegisteredCandidatesCount, GetTotalStudentRegisterData) — restructured only:
                    one Card per post (Post Name as the Card's own header, already visually distinct
                    per the existing enterprise Card component), with that post's Registered/Approved
                    StatCards nested inside it, so the grouping is unmistakable regardless of how many
                    posts exist. */}
                {/* Visual Refinement round 2: `align="stretch"` (antd Row default is "top", i.e.
                    align-items:flex-start) — a 2-line post name like "Law Officer (Banking Officer
                    Gr2)new" made ONLY that card taller, while its same-row siblings stayed their
                    shorter natural height, leaving a visible gap under them before the next row
                    started (confirmed against the reported screenshot). Stretch + `.ent-post-wise-card`
                    height:100% (themes.scss) makes every card in a row match the tallest one, so a
                    long title can no longer create uneven "masonry-style" gaps. The title itself is
                    clamped to 2 lines with an ellipsis (also themes.scss) as a safety net for any
                    future post name longer than that. */}
                <div className="ent-section">
                    <div className="ent-section-title">Post Wise Candidate Registration Count</div>
                    {this.state.postWiseLoading ? <LoadingSpinner /> : (
                        <Row gutter={[16, 16]} align="stretch">
                            {this.state.totalRegisteredCandidatesCount.map((item, index) => (
                                <Col xs={24} sm={12} lg={8} key={index} className="d-flex">
                                    <Card className="ent-post-wise-card" header={<span title={item.Post}>{item.Post}</span>}>
                                        <Row gutter={[12, 12]}>
                                            <Col span={12}>
                                                <StatCard label="Registered" value={item.TotalRegisteredCandidates} tone="info" />
                                            </Col>
                                            <Col span={12}>
                                                <StatCard label="Approved" value={item.TotalApprovedCandidates} tone="success" />
                                            </Col>
                                        </Row>
                                    </Card>
                                </Col>
                            ))}
                        </Row>
                    )}
                </div>

                {/* Sprint 2.4 (Admin Dashboard Modernization): consumes Sprint 2.3's Operational
                    Dashboard, System Health, and Compliance Dashboard APIs, which had no frontend
                    consumer before this sprint. Everything above this comment is unchanged in data/logic. */}
                {this.state.enterpriseLoading ? <LoadingSpinner /> : (
                    <>
                        {this.state.operationalMetrics && (
                            <div className="ent-section">
                                <div className="ent-section-title">Operational Overview</div>
                                <div>
                                    <Row gutter={[16, 16]}>
                                        <Col xs={24} sm={12} md={6}>
                                            <StatCard label="Registrations Today" value={this.state.operationalMetrics.RegistrationsToday} tone="info" />
                                        </Col>
                                        <Col xs={24} sm={12} md={6}>
                                            <StatCard label="Total Registrations" value={this.state.operationalMetrics.TotalRegistrations} tone="info" />
                                        </Col>
                                        <Col xs={24} sm={12} md={6}>
                                            <StatCard label="Failed Email Deliveries" value={this.state.operationalMetrics.FailedEmailDeliveries} tone={this.state.operationalMetrics.FailedEmailDeliveries > 0 ? 'warning' : 'success'} />
                                        </Col>
                                        <Col xs={24} sm={12} md={6}>
                                            <StatCard label="Failed SMS Deliveries" value={this.state.operationalMetrics.FailedSmsDeliveries} tone={this.state.operationalMetrics.FailedSmsDeliveries > 0 ? 'warning' : 'success'} />
                                        </Col>
                                        <Col xs={24} sm={12} md={6}>
                                            <StatCard label="Pending Governance Requests" value={this.state.operationalMetrics.PendingGovernanceRequests} tone={this.state.operationalMetrics.PendingGovernanceRequests > 0 ? 'warning' : 'success'} />
                                        </Col>
                                        <Col xs={24} sm={12} md={6}>
                                            <StatCard label="Failed Aadhaar OTP Requests" value={this.state.operationalMetrics.FailedAadhaarOtpRequests} tone={this.state.operationalMetrics.FailedAadhaarOtpRequests > 0 ? 'warning' : 'success'} />
                                        </Col>
                                        {this.state.operationalMetrics.PaymentStatusCounts && Object.keys(this.state.operationalMetrics.PaymentStatusCounts).map(key => (
                                            <Col xs={24} sm={12} md={6} key={key}>
                                                <StatCard label={'Payments: ' + key} value={this.state.operationalMetrics.PaymentStatusCounts[key]} tone={key === 'Success' ? 'success' : (key === 'Failed' ? 'error' : 'info')} />
                                            </Col>
                                        ))}
                                    </Row>
                                </div>
                            </div>
                        )}

                        {this.state.healthStatus && (
                            <div className="ent-section">
                                <div className="ent-section-title">Health Status</div>
                                <Row gutter={[16, 16]}>
                                    {this.state.healthStatus.map((component, idx) => (
                                        <Col xs={24} sm={12} md={8} key={idx} className="ent-health-status-row">
                                            <span title={component.Component}>{component.Component}</span>
                                            <StatusBadge status={component.Status} />
                                        </Col>
                                    ))}
                                </Row>
                                <div className="text-center mt-3">
                                    <a href={routesAdmin.compliancecenter.path}>View full System Diagnostics &amp; Backup Status in the Compliance Center &rarr;</a>
                                </div>
                            </div>
                        )}

                        {this.state.complianceSummary && (
                            <div className="ent-section">
                                <div className="ent-section-title">Compliance Summary</div>
                                <Row gutter={[16, 16]}>
                                    <Col xs={24} sm={12} md={6}>
                                        <StatCard label="Password Resets Issued" value={this.state.complianceSummary.PasswordResetStatistics.TotalIssued} tone="info" />
                                    </Col>
                                    <Col xs={24} sm={12} md={6}>
                                        <StatCard label="Governance Decisions Logged" value={(this.state.complianceSummary.GovernanceActivity || []).reduce((sum, g) => sum + g.Total, 0)} tone="info" />
                                    </Col>
                                    <Col xs={24} sm={12} md={6}>
                                        <StatCard label="Consent Records" value={(this.state.complianceSummary.ConsentStatistics || []).reduce((sum, c) => sum + c.Total, 0)} tone="info" />
                                    </Col>
                                    <Col xs={24} sm={12} md={6}>
                                        <StatCard label="Audit Event Types Tracked" value={(this.state.complianceSummary.AuditLogStatistics || []).length} tone="info" />
                                    </Col>
                                </Row>
                            </div>
                        )}
                    </>
                )}

            </div>
        )
    };
}

export default Dashboard;